import { type FC, type PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { useZocksQuota } from '../../components/ScopedBlock/hooks'

// Route gate for the scheduling.enabled quota: render nothing while resolved quotas are
// loading (avoids a redirect flash on reload), redirect deep links away when the quota
// is absent so they behave like any unknown route.
export const SchedulingQuotaGate: FC<PropsWithChildren> = ({ children }) => {
  const { hasQuota, isFetching } = useZocksQuota({ refetchQuota: false, pollingInterval: 0 })
  if (isFetching) {
    return null
  }
  return hasQuota('scheduling.enabled.value') ? <>{children}</> : <Navigate to='/workspace' replace />
}
